import { HISTORY_ACTION_MODE } from '@candulabs/craft';
import { Button, Modal } from 'canoe';
import { nanoid } from 'nanoid';
import React, { useMemo } from 'react';

import { useNodeConditional } from 'craft/containers/Conditionals';
import { useEditor } from 'craft/hooks';
import { ThenType } from 'craft/types';
import { SegmentDefinition } from 'dashboard/pages/Segment/components';
import { DefinitionFormRaw } from 'dashboard/pages/Segment/components/DefinitionForm';

interface Props {
  nodeId: string;
  onClose: () => void;
}

const emptySegment = {
  groups: [],
  object: 'Any',
};

export const ChecklistEventModalConditional = ({ nodeId, onClose }: Props) => {
  const { conditional, setConditional } = useNodeConditional(nodeId);
  const { actions } = useEditor();

  const removeStateProvider = () => {
    actions.produceState((state) => {
      // eslint-disable-next-line no-param-reassign
      state.nodes[nodeId].data.custom.states = null;
    }, HISTORY_ACTION_MODE.MERGE);
  };

  const segmentId = useMemo(() => conditional?.if.id || `ds-${nanoid(6)}`, [conditional]);
  return (
    <Modal onClose={onClose} closeOnClickOutside modalWidth="large">
      <Modal.Header css={{ maxWidth: '100%' }} title="Mark Checklist Item as Completed When..." />
      <Modal.Body>
        <DefinitionFormRaw
          definition={conditional?.if?.definition ?? ((emptySegment as any) as SegmentDefinition)}
          segmentId={segmentId}
          onUpdate={(definition) => {
            setConditional({
              if: { id: segmentId, definition },
              then: [{ type: ThenType.ChecklistItem }],
            });
            removeStateProvider();
            onClose();
          }}
        >
          <div css={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Button variant="neutral" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="secondary" type="submit">
              Update
            </Button>
          </div>
        </DefinitionFormRaw>
      </Modal.Body>
    </Modal>
  );
};
